import React, { useContext } from "react";
import { DiseaseGroupContext } from "../../contexts/diseaseGroupContext";

export const HelpButtonExpanded = ({
	onClick,
	color,
	text,
	linkColorOverride,
	textSizeOverride,
	width,
}) => {
	const colorClass = color ? color : "white";

	const { theme } = useContext(DiseaseGroupContext);

	const textSize = textSizeOverride || "text-sm";

	const w = width || "w-4/5";

	const linkColorClass = linkColorOverride || theme.secondary().text();

	return (
		<button
			type={"button"}
			onClick={onClick}
			className={`flex justify-between w-full mx-auto max-w-sm text-left  items-center`}
		>
			{text ? (
				<span className={`block ${textSize} ${w} underline ${linkColorClass}`}>
					{text}
				</span>
			) : null}
			<div className={"ss-icon pt-0.5 text-3xl h-8"}>&#x2753;</div>
		</button>
	);
};
